import React from 'react';
import '../css/statusBadge.css';

export type BadgeVariant =
    | 'published'
    | 'unpublished'
    | 'draft'
    | 'new'
    | 'reviewed'
    | 'scheduled'
    | 'interviewed'
    | 'rejected'
    | 'hired';

export interface StatusBadgeProps {
    variant: BadgeVariant;
    label?: string;
}

const BADGE_CONFIG = {
    published: {
        label: 'Published',
        dotColor: 'rgb(138, 56, 245)',
        bgColor: 'rgb(249, 244, 255)',
        textColor: 'rgb(138, 56, 245)',
    },
    unpublished: {
        label: 'Unpublished',
        dotColor: 'rgb(138, 139, 143)',
        bgColor: 'rgba(237, 238, 239, 0.5)',
        textColor: 'rgb(138, 139, 143)',
    },
    draft: {
        label: 'Draft',
        dotColor: 'rgb(138, 139, 143)',
        bgColor: 'rgba(237, 238, 239, 0.5)',
        textColor: 'rgb(138, 139, 143)',
    },
    new: {
        label: 'New',
        dotColor: '#2AA63C',
        bgColor: '#F3FFF6',
        textColor: '#2AA63C',
    },
    reviewed: {
        label: 'Reviewed',
        dotColor: 'rgb(74, 149, 237)',
        bgColor: 'rgba(227, 239, 255, 0.5)',
        textColor: 'rgb(74, 149, 237)',
    },
    scheduled: {
        label: 'Scheduled',
        dotColor: 'rgb(255, 148, 22)',
        bgColor: 'rgba(255, 148, 22, 0.1)',
        textColor: 'rgb(255, 148, 22)',
    },
    interviewed: {
        label: 'Interviewed',
        dotColor: '#FF7411',
        bgColor: '#FFEBDD',
        textColor: '#FF7411',
    },
    rejected: {
        label: 'Rejected',
        dotColor: '#FE566B',
        bgColor: '#FFECEF',
        textColor: '#FE566B',
    },
    hired: {
        label: 'Hired',
        dotColor: '#07AEDD',
        bgColor: '#DEF8FF',
        textColor: '#07AEDD',
    },
} satisfies Record<BadgeVariant, { label: string; dotColor: string; bgColor: string; textColor: string }>;

const WorkflowStatusBadge: React.FC<StatusBadgeProps> = ({ variant, label }) => {
    const config = BADGE_CONFIG[variant];

    return (
        <span
            className="scl--cms-components-statusBadge"
            style={{
                background: config.bgColor,
                color: config.textColor,
            }}
        >
            <span
                className="scl--cms-components-statusBadge-dot"
                style={{ background: config.dotColor }}
            />
            <span className='badge-scl'>
                {label ?? config.label}
            </span>
        </span>
    );
};

export default WorkflowStatusBadge;